<div class="wrapper">

  @if (!(showQueue$ | async)) {
    <div class="backgroundImageContainer">
      <img class="backgroundImage" [src]="(originImageUrl$ | async)">
    </div>
  }

  @if (!(showQueue$ | async)) {
    <div class="frontImageContainer">
      <img class="frontImage" [src]="(originImageUrl$ | async)">
    </div>
  }

  @if (showQueue$ | async) {
    <div class="frontImageContainer">
      <tun-queue-full-icon-v5 class="icon queue-icon"></tun-queue-full-icon-v5>
    </div>
  }

  <div
    class="remoteOverlay"
    [style.opacity]="((showOverlay$ | async) && canShowRemoteOverlay)?1:0"
    [style.visibility]="((showOverlay$ | async) && canShowRemoteOverlay) ? 'visible' : 'hidden'"
    >
    @if (canShowRemoteOverlay) {
      <tun-remote-info-buttons-view
        class="remoteInfoButtons"
        [canShowTooltips]="true"
        >
      </tun-remote-info-buttons-view>
    }
  </div>


</div>
